import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles, Theme } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Skeleton from '@material-ui/lab/Skeleton'
import React from 'react'

const useStyles = makeStyles((theme: Theme) => ({
    submissionStatusContainer: {
        maxHeight: 27,
        height: 27,
        display: 'flex',
        width: 'max-content',
    },
    statusImage: {
        height: 30,
        marginRight: theme.spacing(1),
    },
}))
const useStylizedTextStyles = makeStyles((theme: Theme) => ({
    dialogSubmissionStatusStyleDialog: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginLeft: theme.spacing(0.5),
        width: 'max-content',
    },
    greenBox: {
        width: 307,
        height: 34,
        background: 'linear-gradient(89.99deg, #006F47 0.01%, #00A776 99.58%)',
        display: 'flex',
        transform: 'matrix(-1, 0, 0, 1, 0, 0)',
    },
    textDialog: {
        color: theme.palette.common.white,
        fontSize: pxToRem(13),
        fontWeight: 500,
        textTransform: 'uppercase',
        transform: 'matrix(-1, 0, 0, 1, 0, 0)',
    },
}))

export interface ProductListingDialogSubmissionStatusProps {
    variant?: string
    loading?: boolean
}

const ApprovedForGeneralDistributionStylized = React.memo(() => {
    const stylizedTextClasses = useStylizedTextStyles()
    return (
        <GridContainer
            className={`stylizedApprovedForGeneralDistributionText ${stylizedTextClasses.dialogSubmissionStatusStyleDialog}`}
            justifyContent="center"
            alignItems="flex-end"
        >
            <GridItem
                justifyContent="center"
                alignItems="center"
                className={stylizedTextClasses.greenBox}
            >
                <Typography
                    component="span"
                    className={stylizedTextClasses.textDialog}
                >
                    General Distribution
                </Typography>
            </GridItem>
        </GridContainer>
    )
})

const ProductListingDialogSubmissionStatus: React.FC<ProductListingDialogSubmissionStatusProps> = ({
    variant,
    loading,
}) => {
    const classes = useStyles()

    if (loading) {
        return (
            <GridContainer
                justifyContent="flex-end"
                alignItems="center"
                className={classes.submissionStatusContainer}
            >
                <Skeleton
                    className="loadingSkeleton"
                    width={50}
                    variant="text"
                    animation="pulse"
                />
            </GridContainer>
        )
    }

    let content = (
        <GridContainer
            justifyContent="flex-end"
            alignItems="center"
            className={classes.submissionStatusContainer}
        ></GridContainer>
    )
    if (variant === 'Premium Proprietary' || variant === 'Premium') {
        content = <ApprovedForGeneralDistributionStylized />
    } else if (variant === 'Premium MasterSpec' || variant === 'Manufacturer') {
        content = (
            <GridContainer
                justifyContent="flex-end"
                alignItems="center"
                className={classes.submissionStatusContainer}
            >
                <img
                    className={classes.statusImage}
                    alt="Approved For MasterSpec"
                    src="https://avitrucdn.azureedge.net/knowledgepoint/masterspec_simplified_25.png"
                />
            </GridContainer>
        )
    }
    return content
}

export default ProductListingDialogSubmissionStatus
